import { createFileRoute, redirect } from '@tanstack/react-router';
import { isOnboardingIsolated } from '@aegislab/shared';
import { OAuthConsentRoute } from './-OAuthConsentRoute';
import { useAuthStore } from '@/shared/model';

/**
 * /oauth/consent?request= — 백엔드 `GET /oauth/authorize` 가 302 로 보내는 승인 화면
 * (docs/plan/mcp-oauth-claude-connector-plan.md §4.2-4, 구현 메모 §10).
 * 미로그인이면 목적지를 실어 로그인으로 보낸다 — 같은 request 로 돌아와야 승인이 이어진다.
 */
export const Route = createFileRoute('/oauth/consent')({
  validateSearch: (search: Record<string, unknown>): { request: string } => ({
    request: typeof search.request === 'string' ? search.request : '',
  }),
  beforeLoad: ({ location }) => {
    const user = useAuthStore.getState().user;
    if (!user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    // 온보딩 격리 (CP1 D1): 격리 중인 사용자는 외부 앱 연결도 미룬다 — /settings/mcp-tokens 와 같은 규칙.
    if (isOnboardingIsolated(user)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/' });
    }
  },
  component: OAuthConsentRoute,
});
